import { useState, useEffect } from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "variables/charts.js";
import dataProvider from "dataProvider";
import Header from "components/Headers/Header.js";

const getChartData = async (data) => {
  return new Promise(async (resolve, reject) => {
    let i = 0;
    let labels = [];
    let values = [];
    var daysArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var from, to, first, last, month;
    from = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    to = new Date();
    first = from.getDay();
    Object.keys(data).map(key => {

      //const anyAdult = Object.keys(data).some(dat => dat.title != 38);
      //index = datas.findIndex( x => x.Id === fieldId );

      labels.push(key);
      values.push(data[key]);
      i++;
    })
    if (i == Object.keys(data).length) {
      let chart = [{
        labels: labels,
        datasets: [
          {
            label: "Word Orders",
            data: values,
          },
        ],
      }];
      resolve(chart)
    }
  })
}
const getChartDaysData = async (data, type) => {
  return new Promise(async (resolve, reject) => {
    let i = 0;
    let labels = [];
    let values = [];
    var daysArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var from, to, day, index;
    from = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    to = new Date();
    day = from.getDay();
    for (let step = 0; step < 7; step++) {
      index = data.findIndex(x => x.title === daysArr[day]);
      if (index >= 0) {
        labels.push(data[index].title);
        values.push(data[index].count);
      }
      else {
        labels.push(daysArr[day]);
        values.push(0);
      }
      day++;
      if (day >= 7) { day = 0; }
      if (labels.length == 7) {
        let chart = [{
          labels: labels,
          datasets: [
            {
              label: type,
              data: values,
              maxBarThickness: 10,
            },
          ],
        }];
        resolve(chart)
      }
    }
  })
}
const Index = (props) => {
  const [chartMonthData, setChartMonthData] = useState(false);
  const [chartWeekData, setChartWeekData] = useState(false);
  const [chartTechData, setChartTechData] = useState(false);
  const [chartTenantsData, setChartTenantsData] = useState(false);
  const [chartFlag, setChartFlag] = useState('month');
  const [products, setProducts] = useState(false);
  const [category, setCategory] = useState(false);
  const [brands, setBrands] = useState(false);
  const [suppliers, setSuppliers] = useState(false);
  const [locations, setLocations] = useState(false);
  const [flag, setFlag] = useState(false);

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }
  useEffect(() => {


    dataProvider.getDashboard({}).then(async ({ data }) => {
      if (data.month) {
        let data1 = await getChartData(data.month);
        setChartMonthData(data1[0]);
      }
      if (data.week) {
        let data1 = await getChartDaysData(data.week, 'Word Orders');
        setChartWeekData(data1[0]);
      }
      if (data.tech) {
        let data1 = await getChartDaysData(data.tech, 'Technicians');
        setChartTechData(data1[0]);
      }
      if (data.tenants) {
        let data1 = await getChartDaysData(data.tenants, 'Tenants');
        setChartTenantsData(data1[0]);
      }
    });



    dataProvider.getList('products', { params: { pagination: { page: 1, perPage: 800 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setProducts(data); })
    dataProvider.getList('product_categories/list', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setCategory(data[0].data ? data[0].data : null); })
    dataProvider.getList('brands', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setBrands(data); })
    dataProvider.getList('suppliers', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setSuppliers(data); })
    dataProvider.getList('locations/list', { params: { pagination: { page: 1, perPage: 200 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setLocations((data?.length && data[0]) ? data[0]?.data : {}); })
  }, []);

  const toggleNavs = (e, chart) => {
    e.preventDefault();
    setChartFlag(chart);
    setFlag(!flag);
  };
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col className="mb-5 mb-xl-0" xl="8">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-light ls-1 mb-1">
                      Overview
                    </h6>
                    <h2 className="text-white mb-0">Total Work Orders</h2>
                  </div>
                  <div className="col">
                    <Nav className="justify-content-end" pills>
                      <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: chartFlag === 'month',
                          })}
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 'month')}
                        >
                          <span className="d-none d-md-block">Month</span>
                          <span className="d-md-none">M</span>
                        </NavLink>
                      </NavItem>
                      {chartWeekData && (
                        <NavItem>
                          <NavLink
                            className={classnames("py-2 px-3", {
                              active: chartFlag === 'week',
                            })}
                            data-toggle="tab"
                            href="#pablo"
                            onClick={(e) => toggleNavs(e, 'week')}
                          >
                            <span className="d-none d-md-block">Week</span>
                            <span className="d-md-none">W</span>
                          </NavLink>
                        </NavItem>
                      )}
                    </Nav>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                {chartFlag === 'month' && chartMonthData && (
                  <div className="chart">
                    <Line
                      data={chartMonthData}
                      options={chartExample1.options}
                      getDatasetAtEvent={(e) => console.log(e)}
                    />
                  </div>
                )}
                {chartFlag === 'week' && chartWeekData && (
                  <div className="chart">
                    <Line
                      data={chartWeekData}
                      options={chartExample1.options}
                      getDatasetAtEvent={(e) => console.log(e)}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      Performance
                    </h6>
                    <h2 className="mb-0">Total Technicians</h2>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {chartTechData && (
                  <div className="chart">
                    <Bar
                      data={chartTechData}
                      options={chartExample2.options}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="8">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Inventory</h3>
                  </div>
                  {/* <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      See all
                    </Button>
                  </div> */}
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" style={{
                maxHeight: '900px',
                overflowY: 'auto',
                display: 'block'
              }} responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Product Name</th>
                    <th scope="col">Category</th>
                    <th scope="col">Brand</th>
                    <th scope="col">Price</th>
                    {/* <th scope="col">Stock</th> */}
                    <th scope="col">Supplier</th>
                  </tr>
                </thead>
                <tbody>
                  {products && products.length > 0 && (
                    products.map((product, index) => (
                      <tr>
                        <th scope="row">{product.name}</th>
                        <td style={{ fontWeight: 'bold' }}>{product?.category?.category || '-'}</td>
                        <td>{product?.brand?.brand || '-'}</td>
                        <td>{product.price}</td>
                        {/* <td style={{color:'green'}}>{product.status === 1 ? 'Instock': 'Outstock'}</td> */}
                        <td>{product.supplier ? product.supplier.supplier : ''}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      Performance
                    </h6>
                    <h2 className="mb-0">Total Tenants</h2>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {chartTenantsData && (
                  <div className="chart">
                    <Bar
                      data={chartTenantsData}
                      options={chartExample2.options}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
            <Card className="shadow" style={{ marginTop: 40 }}>
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Locations</h3>
                  </div>
                  {/* <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      See all
                    </Button>
                  </div> */}
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" style={{
                maxHeight: '500px',
                overflowY: 'auto',
                display: 'block'
              }} responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Location</th>
                    {/* <th scope="col">Area</th> */}
                  </tr>
                </thead>
                <tbody>
                  {locations && locations.length > 0 && (
                    locations.map((item, index) => (
                      <tr>
                        <th scope="row">{item.location}</th>
                        {/* <td>{item.area}</td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Index;
